import React from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

interface KPITableProps {
  headers: string[];
  kpiData: string[][];
}

const KPITable: React.FC<KPITableProps> = ({ headers, kpiData }) => {
  if (!headers.length || !kpiData.length) {
    return (
      <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>
          Identified KPIs
        </Typography>
        <Typography color="text.secondary">
          No KPI columns found in the data. Please ensure your CSV file contains columns with "KPI" in their headers.
        </Typography>
      </Paper>
    );
  }

  return (
    <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        Identified KPIs
      </Typography>
      <Typography variant="body2" color="text.secondary" paragraph>
        Found {headers.length} KPI columns with {kpiData.length} unique values
      </Typography>
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell key={index} sx={{ fontWeight: 'bold' }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {kpiData.map((row, rowIndex) => (
              <TableRow key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <TableCell key={cellIndex}>
                    {cell}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default KPITable; 